import { StrictMode } from 'react';
import Amplify from 'aws-amplify';
import aws_config from './aws-config';
Amplify.configure(aws_config);

import ReactDOM from 'react-dom';
import App from './app.component';
import './index.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
